import { render, staticRenderFns } from "./lead-source-widget.vue?vue&type=template&id=97fd1d1e"
import script from "./lead-source-widget.vue?vue&type=script&lang=js"
export * from "./lead-source-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports